import React, { useState, useEffect, useRef } from "react";
import GuidesList from "./GuidesList";
import GuideForm from "./GuideForm";
import { usePopup } from "./PopupContext";

const ManageGuides = () => {
    const hasFetched = useRef(false)
    const [guides, setGuides] = useState([]);
    const [showGuideDetails, setShowGuideDetails] = useState(false);
    const [selectedGuide, setSelectedGuide] = useState(null);
    const [guideTypes, setGuideTypes] = useState([])
    const pop = usePopup()

    const setShowTheGuideDetails = (bool) => {
        setSelectedGuide(bool);
        setShowGuideDetails(bool);
    }

    // Fetch guides data from API
    const fetchGuides = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/guides`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${window.localStorage.getItem('adminToken')}`
            }
        });
        const data = await response.json();
        if (data.success) {
            setGuides(data.guides);
            console.log(data.guides)
        } else {
            console.error("Failed to fetch guides");
        }
    };

    // Fetch guide types data from API
    const fetchGuideTypes = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/guide-types`, {
            headers: {
                'Authorization': `Bearer ${window.localStorage.getItem('adminToken')}`
            }
        });
        const data = await response.json();
        if (data.success) {
            setGuideTypes(data.guideTypes);
        } else {
            console.error("Failed to fetch guides");
        }
    }

    const updateGuide = async (guide) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/guide`, {
                method: 'PATCH',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${window.localStorage.getItem('adminToken')}`
                },
                body: JSON.stringify(guide)
            });
            const data = await response.json();
            if (data.success) {
                pop(data.message, 'flash', data.success)
                setShowTheGuideDetails(false);
                fetchGuides();
            } else {
                pop(data.message, 'flash', data.success)
                console.error("Failed to update guide");
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (!hasFetched.current) {
            hasFetched.current = true
            fetchGuides()
        }
        fetchGuideTypes()
    }, []);

    return (
        <section className="main-body-section manage-guides-section">
            {!showGuideDetails && guides.length > 0 && <GuidesList guides={guides} showGuideDetails={setShowTheGuideDetails} />}
            {!showGuideDetails && guides.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 20 }}>
                    <h3>No guides found.</h3>
                    <p>Please check back later.</p>
                </div>
            )}
            {showGuideDetails && selectedGuide && (
                <GuideForm 
                    guideTypes={guideTypes}
                    selectedGuide={selectedGuide}
                    updateGuide={updateGuide}
                    setShowGuideDetails={setShowGuideDetails}/>
            )}
        </section>
    );
}

export default ManageGuides;